// Dynamically set the webpack public path at runtime below
// We use the current script source to determine the correct path where the bundle is hosted.
// This is critical for dual-bundle/code-splitting so that lazy-loaded chunks are fetched
// from the same directory as the main bundle (e.g. /path/vendors.bundle.js instead of /vendors.bundle.js).
// If we just use the host root, lazy-loaded chunks would 404 in environments where the app is hosted under a sub-path.
// Documentation: http://webpack.github.io/docs/configuration.html#output-publicpath

/* eslint-disable no-undef, no-var */
if (document.currentScript && document.currentScript.src) {
  var _src = document.currentScript.src;
  __webpack_public_path__ = _src.substring(0, _src.lastIndexOf('/') + 1);
} else {
  // Fallback
  __webpack_public_path__ =
    window.location.protocol + '//' + window.location.host + '/';
}
/* eslint-enable no-undef, no-var */
